module.exports = __webpack_public_path__ + "assets/img/create.b09650e6.jpg";